import TrendSummary from './TrendSummary';
import './TrendSummary.scss';

export default TrendSummary;